import { ColGroupDef } from 'ag-grid-community'
import { ColumnType } from '../../../../containers/commons/AgGrid'
import { intl } from '../../../../../i18n'
import { programItemRowService } from '../../programItemRowService'
import {
  GanttRowItem,
  ganttRowItemService,
} from '../../../../containers/commons/AgGrid/components/cell/custom/gantt/GanttRowItem'
import {
  ProgramManagementRow,
  ProgramManagementGridContext,
} from '../../programManagement'
import {
  AggregateField,
  WbsItemType,
} from '../../../../../domain/entity/WbsItemEntity'

const getProgressRate = (
  data: ProgramManagementRow,
  context: ProgramManagementGridContext
): number | undefined => {
  const progress = data.progress
  if (!progress) return undefined

  const isTask = context.aggregateTarget === WbsItemType.TASK
  const isCount = context.aggregateField === AggregateField.WBS_ITEM_COUNT
  const activeProgress = isTask
    ? isCount
      ? progress.taskCount
      : progress.taskWorkload
    : isCount
      ? progress.deliverableCount
      : progress.deliverableWorkload

  if (!activeProgress || activeProgress.total === 0) return undefined
  return activeProgress.completed / activeProgress.total
}

export const getGanttRowItem = (
  data: ProgramManagementRow,
  context?: ProgramManagementGridContext
): GanttRowItem | undefined => {
  if (!data) return undefined
  return {
    uuid: data.uuid,
    wbsItemUuid: data.wbsItemUuid,
    scheduledDate: data.scheduledDate,
    status: data.status,
    displayName: data.displayName,
    type: data.type,
    iconUrl: data.iconUrl,
    progressRate: context ? getProgressRate(data, context) : undefined,
    projectPlanCumulation: data.projectPlanCumulation,
    // プログラム行・グループ行は自身の予定日を持てるため、予定線のドラッグ編集を許可する
    editable: programItemRowService.isScheduledDateEditable(data),
  }
}

export const ganttColumnGroup: ColGroupDef = {
  headerName: intl.formatMessage({ id: 'projectOverview.ganttChart' }),
  headerGroupComponent: 'ganttHeaderGroupComponent',
  children: [
    {
      field: 'ganttChart',
      headerName: intl.formatMessage({ id: 'projectOverview.ganttChart' }),
      type: [ColumnType.gantt],
      cellRendererParams: {
        // getGanttRowItem 指定によりデータ取得経路が GanttRowItem に切り替わる
        // （wbsItem ボディ直読み・レガシー編集経路・依存カスケードは使われない）
        getGanttRowItem: (data: ProgramManagementRow) => getGanttRowItem(data),
        getVisualType: ganttRowItemService.getBarVisualType,
        showDependency: false,
      },
      width: 560,
      minWidth: 150,
      cellStyle: {
        borderColor: 'transparent',
      },
      valueGetter: params => {
        const data = params.data as ProgramManagementRow | undefined
        if (!data?.scheduledDate) return undefined
        const rowItem = getGanttRowItem(
          data,
          params.context as ProgramManagementGridContext
        )
        if (!rowItem) return undefined
        return JSON.stringify(rowItem)
      },
    },
  ],
}
